import { render, staticRenderFns } from "./RefundReviewList.vue?vue&type=template&id=16b5bc18&scoped=true"
import script from "./RefundReviewList.vue?vue&type=script&lang=js"
export * from "./RefundReviewList.vue?vue&type=script&lang=js"
import style0 from "./RefundReviewList.vue?vue&type=style&index=0&id=16b5bc18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b5bc18",
  null
  
)

export default component.exports